import { Observable } from 'rxjs'

export class CookiesComponent {
    constructor() {
        this.inputAceite = document.getElementById('input-aceite')
        this.closeButton = document.getElementById('close-button')
        this.init()
    }

    init() {
        
        this.cookiesVerify()

        Observable.fromEvent(document.body, 'click')
            .subscribe((e) => {
                let target = e.srcElement.classList
                let close = true
                for (let i=0; i < target.length; i++) {
                    if (target[i] == 'termos') close = false
                }
                if (close == true) this.fecharModal()
            })


        if (this.inputAceite != null) {
            Observable.fromEvent(this.inputAceite, 'change')
                .subscribe(() => {
                    document.cookie = 'cookies=true;max-age=31536000'
                    this.fecharModal
                })
        }

        if (this.closeButton != null) {
            Observable.fromEvent(this.closeButton, 'click')
                .subscribe(this.fecharModal)
        }

    }

    abrirModal() {
        let modal = document.getElementById('cookies')
        if (modal != null) modal.style.display = 'block'
    }

    fecharModal() {
        let modal = document.getElementById('cookies')
        if (modal != null) modal.style.display = 'none'
    }

    cookiesVerify() {
        let cookies = document.cookie
        let cookiesAccepted = false
        if (cookies.indexOf('cookies') != -1) cookiesAccepted = true
        if (!cookiesAccepted) this.abrirModal()
    }

}


// WEBPACK FOOTER //
// ./src/main/webapp/assets/js/components/cookies/cookies.component.js